import {Pressable, StyleSheet, View} from "react-native";
import {Color} from "@/lib/styles";
import Icon from "@/lib/components/Icon";
import {chat} from "@/lib/proto";
import {formatSince} from "@/lib/time";
import {useRouter} from "expo-router";
import SecondaryText from "@/lib/components/SecondaryText";
import PrimaryText from "@/lib/components/PrimaryText";
import {UserAvatarFromProto} from "@/lib/types";
import Avatar from "@/lib/components/Avatar";
import Chat = chat.Chat;
import ChatMessage = chat.ChatMessage;
import {useChat} from "@/lib/components/ChatProvider";
import Badge from "@/lib/components/Badge";

type Props = {
    // avatar: UserAvatar | GroupAvatar,
    color: string,
    contrastColor: string,
    id: string,
    chat: Chat,
    messages: Map<string, ChatMessage>,
    // badgeColor: string,
    // badge?: string,
    // checked?: boolean,
    // onPress: (avatar: UserAvatar | GroupAvatar) => any,
    // onEdit?: () => any,
}

export default function ChatRow(props: Props) {
    // const isEditable = props.onEdit !== undefined;
    // const userAvatar = props.avatar as UserAvatar;
    // const groupAvatar = props.avatar as GroupAvatar;
    // const {isFriend} = useAccount();

    const router = useRouter();

    const lastActivity = props.chat.lastActivity?.unixMsec as number || Date.now();
    const avatars = props.chat.participants.map(p => UserAvatarFromProto(p));
    const {unreadMessagesForChat} = useChat();
    const numUnread = unreadMessagesForChat(props.chat.id);

    return (
        <Pressable
            style={[styles.container, {backgroundColor: props.color}]}
            onPress={() => {
                router.push(`/chat/${props.id}`);
            }}
        >
            <View style={styles.meta}>
                {props.chat.event &&
                    <View style={styles.left}>
                        <Icon kind={"event"} color={Color.SecondaryText}/>
                        <SecondaryText>{props.chat.event?.title}</SecondaryText>
                        {numUnread > 0 &&
                            <Badge
                                size={16}
                                round={true}
                                title={numUnread.toString()}
                                color={Color.Red}
                                contrastColor={Color.PrimaryText}
                            />
                        }
                    </View>
                }
                {/*{props.chat.group && <SecondaryText></SecondaryText>}*/}
                {/*{props.chat.user && <SecondaryText></SecondaryText>}*/}
                <View style={styles.right}>
                    <Icon kind={"clock"} size={12} color={Color.SecondaryText}/>
                    <SecondaryText>{formatSince(new Date(lastActivity))}</SecondaryText>
                </View>
            </View>
            <View style={styles.main}>
                <View style={styles.avatars}>
                    {avatars.slice(0, 4).map(avatar => (
                        <View key={avatar.id} style={styles.avatar}><Avatar avatar={avatar}/></View>
                    ))}
                </View>
                <PrimaryText>{props.chat.name}</PrimaryText>
            </View>
        </Pressable>
    )
}

export const styles = StyleSheet.create({
    container: {
        flexDirection: "column",
        gap: 8,
        padding: 8,
    },
    meta: {
        flexDirection: "row",
        flexWrap: "nowrap",
        width: "100%",
        alignItems: "center",
        gap: 16,
        justifyContent: "space-between",
    },
    left: {
        overflow: "hidden",
        flexWrap: "nowrap",
        flexShrink: 1,
        flexDirection: "row",
        gap: 4,
        alignItems: "center",
    },
    right: {
        flexDirection: "row",
        flexWrap: "nowrap",
        gap: 4,
        alignItems: "center",
    },
    main: {
        flexDirection: "row",
        flexWrap: "nowrap",
        alignItems: "center",
        gap: 8,
    },
    avatars: {
        flexDirection: "row",
        alignItems: "center",
        marginLeft: 16,
    },
    avatar: {
        marginLeft: -16,
    }
})